export default __webpack_public_path__ + "static/media/sicoob-logo.fdcef54f.png";